var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPowerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#power-icon_svg__clip0_7114_140515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.079 1.28l38.476 39.337c3.023 3.091 3.485 7.586 1.028 9.99l-49.15 48.072c-2.457 2.404-6.94 1.841-9.964-1.25L-.006 58.093C-3.03 55-3.492 50.506-1.035 48.102L48.115.03c2.457-2.404 6.94-1.841 9.964 1.25z",
    fill: "#F4F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.082 60.081c-8.528-8.528-8.528-22.408 0-30.936a21.91 21.91 0 0116.685-6.374l3.12.173-.345 6.24-3.12-.172a15.65 15.65 0 00-11.92 4.553c-6.092 6.092-6.092 16.005 0 22.097 6.091 6.092 16.005 6.092 22.097 0a15.65 15.65 0 004.553-11.92l-.173-3.12 6.241-.346.173 3.12a21.911 21.911 0 01-6.375 16.685c-8.528 8.528-22.408 8.528-30.936 0z",
    fill: "#E1EAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.808 26.936l4.419 4.42-13.258 13.257-4.42-4.419 13.259-13.258z",
    fill: "#E1EAF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "power-icon_svg__clip0_7114_140515"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/power-icon.09cc454abb659620bd3523faf092b741.svg";
export { SvgPowerIcon as ReactComponent };